import { Component, inject, Signal, signal } from '@angular/core';
import { Divider } from "primeng/divider";
import { Drawer } from "primeng/drawer";
import { ModelFormComponent } from "../../forms/model-form/model-form";
import { AbstractPageComponent, BasePageComponent } from '@spike/scaffolds';
import { Button } from 'primeng/button';
import { ModelStoreService } from '../../services/model-store.service';
import { ModelApiEnum } from 'src/app/config/entity-api.enum';
import { EntityModel } from '../../models/entity-model.model';

interface ModelConfig{
  label:string,
  apiEnum: ModelApiEnum,
  list: Signal<EntityModel[]>
}
@Component({
  imports: [BasePageComponent, Divider, Drawer, ModelFormComponent, Button],
  selector: 'spike-model-page',
  templateUrl: './model-page.html'
})
export class ModelPageComponent extends AbstractPageComponent{
  //inject  
  private readonly modelStoreService = inject(ModelStoreService);


  //local state
  public selectedModel = signal<EntityModel | undefined>(undefined); 
  public selectedModelConfig = signal<ModelConfig | undefined>(undefined); 
  public isDialogVisible = signal(false);


  
  public modelConfigList: ModelConfig[]=[
      {
        label:'Clienti',
        apiEnum: ModelApiEnum.CLIENT,
        list: this.modelStoreService.get(ModelApiEnum.CLIENT)
        
      },
      {
        label:'Dipendenti',
        apiEnum: ModelApiEnum.EMPLOYEE,
        list: this.modelStoreService.get(ModelApiEnum.EMPLOYEE)
      },
      {
        label:'Macchine',
        apiEnum: ModelApiEnum.MACHINE,
        list: this.modelStoreService.get(ModelApiEnum.MACHINE)
      },
      {
        label:'Fornitori',
        apiEnum: ModelApiEnum.SUPPLIER,
        list: this.modelStoreService.get(ModelApiEnum.SUPPLIER)
      },
      {
        label:'Veicoli',
        apiEnum: ModelApiEnum.VEHICLE,
        list: this.modelStoreService.get(ModelApiEnum.VEHICLE)
      }, 
      {
        label:'Tipi Materiale',
        apiEnum: ModelApiEnum.EQUIPMENT,
        list: this.modelStoreService.get(ModelApiEnum.EQUIPMENT)
      },  
      {
        label:'Tipi Operazione',
        apiEnum: ModelApiEnum.OPERATION,
        list: this.modelStoreService.get(ModelApiEnum.OPERATION)
      }, 
    ];


  

  onSelect(modelConfig: ModelConfig) {
    let entityModel=modelConfig.list()[0];
    this.selectedModel.set(entityModel);
    this.selectedModelConfig.set(modelConfig);
    this.isDialogVisible.set(true);
  }  

  async onSave(entityModel: EntityModel){
    await this.modelStoreService.save(this.selectedModelConfig()!.apiEnum, entityModel);
    this.isDialogVisible.set(false);
    this.selectedModel.set(undefined);
    this.selectedModelConfig.set(undefined);
  }




}

